<template>
  <div class="container">


    <div class="logoTitle" v-show="!showReport">Face AI Fast Scan
    </div>

    <div class="box2" v-show="!showReport">
      <!-- <h2 class="box_title">{{ tltName }}</h2> -->
      <div class="box_title">
        <div v-if="tltName !== 'Detection successful'"
          style="width: 100%; text-align: center; margin-top: 10px;  font-size: 36px;">
          {{ tltName }} <span v-if="tltName === 'start recording'">{{ countdown }}s</span>
        </div>
        <div v-else style="width: 100%; text-align: center; margin-top: 10px;  font-size: 36px;">

          {{ tltName }} {{ countdown1 }}s
        </div>
      </div>

      <div class="scan-area">
        <div class="video_bg">
          <div v-show="tltName !== 'Detection successful'"
            style="width: 100%; ; height: 100%; border-radius: 50%; margin: 0 auto; position: relative; z-index:2">
            <div v-if="isShow"
              style="position: absolute;left: 50%; top: 50%; transform: translate(-50%,-50%); font-size: 80px; color: rgba(19, 255, 252, .9);">
              {{
                countdown2 }}
            </div>
          </div>
          <div class="vodeo_mtk"> </div>
          <video ref="video" style="display: none;"></video>
          <canvas ref="canvas" id="canvas"></canvas>

        </div>
        <div class="scan-line"></div>
        <div class="progress " v-show="showProgress">
          <el-progress :percentage="progress" :status="progressStatus" />
        </div>

      </div>
    </div>
    <Report v-if="showReport" :reportData="reportData" @trigger-event="handleTriggerEvent" />
  </div>
</template>

<script lang="ts" setup>
import * as faceApi from 'face-api.js';
import { ref, onMounted, onBeforeUnmount, nextTick } from 'vue'
import Report from './report.vue' // 引入报告组件
// import { fa } from 'element-plus/es/locales.mjs';

// import { ElMessage } from 'element-plus'
// import { useRouter } from 'vue-router' // 导入 useRouter 钩子
// 导入 Velocity 库
// import Velocity from 'velocity-animate'
// 定义进度条的百分比和状态
const progress = ref(0);// 初始进度为0%
const progressStatus = ref('');

// 定义反应式变量
const video = ref<HTMLVideoElement | null>(null)
const canvas = ref<HTMLCanvasElement | null>(null)
const timeout = ref<number | null>(null)
const options = ref<any | null>(null)
const MediaStream = ref<MediaStream | null>(null)
const index = ref<number>(0)
const picture = ref<string>('')

const showReport = ref(false)
const handleTriggerEvent = async () => {
  showReport.value = false
  if (timer1.value) clearInterval(timer1.value);
  timer1.value = null;
  index.value = 0;
  countdown1.value = 30;
  tltName.value = 'Please aim at the camera';
  progress.value = 0
}

// 初始化 face-api.js 和模型加载
const init = async () => {
  //装桌面程序
  // await faceApi.nets.ssdMobilenetv1.loadFromUri("./models")
  // await faceApi.loadFaceLandmarkModel("./models")
  //打包成pc端
  await faceApi.nets.ssdMobilenetv1.loadFromUri("/models")
  await faceApi.loadFaceLandmarkModel("/models")
  options.value = new faceApi.SsdMobilenetv1Options({
    minConfidence: 0.80, // 0.1 ~ 0.9
  })
  cameraOptions() // 启动摄像头后开始识别
}

// 摄像头设置
const cameraOptions = () => {
  if (navigator.mediaDevices) {
    navigator.mediaDevices
      .getUserMedia({ audio: false, video: true })
      .then((stream) => {
        MediaStream.value = stream
        if (video.value) {
          video.value.srcObject = stream
          video.value.play()
        }
        recognizeFace() // 开始识别
      })
      .catch((err) => {
        console.error(err)
      })
  } else {
    window.alert("该浏览器不支持开启摄像头，请更换最新版浏览器")
  }
}

// 人脸识别函数
const recognizeFace = async () => {
  if (video.value?.paused) return

  const width = window.innerWidth
  const height = window.innerHeight

  // 设置画布大小为视频大小
  if (canvas.value) {
    canvas.value.width = width
    canvas.value.height = height
    const context = canvas.value.getContext('2d')
    if (video.value) {
      context?.drawImage(video.value, 0, 0, width, height);
    }
    if (options.value) {
      const results = await faceApi.detectAllFaces(canvas.value, options.value).withFaceLandmarks()
      if (results.length === 1) {
        faceApi.draw.drawDetections(canvas.value, results)
        if (index.value === 0) {
          progress.value = 0
          index.value = 1
          picture.value = ''
          tltName.value = 'Facial recognition';
          isShow.value = true;
          staff.value = 1;
          startCountdown2();
          // photoShoot() // 照片拍摄函数（可以添加实际逻辑）
        }
      }
    }
  }

  // 每隔100ms继续识别
  timeout.value = setTimeout(() => {
    recognizeFace()
  }, 100) as unknown as number;
}



// 在组件销毁前清除超时和停止视频流
onBeforeUnmount(() => {
  if (timeout.value) clearTimeout(timeout.value)
  if (MediaStream.value) {
    MediaStream.value.getTracks().forEach(track => track.stop())
  }
})


// State variables
const tltName = ref('Please aim at the camera');
const isShow = ref(false);
const staff = ref(0);
const countdown = ref(10);
const countdown1 = ref(30);
const countdown2 = ref(3);
const timer = ref<null | ReturnType<typeof setInterval>>(null);
const timer1 = ref<null | ReturnType<typeof setInterval>>(null);
const timer2 = ref<null | ReturnType<typeof setInterval>>(null);

const dataList = ref<any>({});

const recorder = ref<MediaRecorder | null>(null);


//拍照并上传
// const photoShoot = async () => {
//   if (canvas.value) {
//     canvas.value.toBlob(async (blob) => {
//       const formData = new FormData();
//       formData.append("file", blob!, "screenshot.png");
//       let react = {
//         method: 'POST',
//         body: formData,
//       }
//       console.log(react);

//       try {
//         //  const response = await window.electron.fetchApi('/nologin/compareFaces', react);
//         await fetch('/data/nologin/compareFaces', {
//           method: 'POST',
//           body: formData
//         })
//           .then(response => response.json())
//           .then(data => {
//             if (data.msg === '操作成功') {
//               dataList.value = data.data;
//               tltName.value = 'Facial recognition';
//               isShow.value = true;
//               staff.value = 0;
//               startCountdown2();
//               console.log("拍照成功");
//             } else {
//               tltName.value = 'Facial recognition';
//               isShow.value = true;
//               staff.value = 1;
//               startCountdown2();
//             }
//           })



//       } catch (error) {
//         console.error('Error:', error);
//       }
//     }, 'image/png');

//   }
// };

// 开始录制倒计时3秒
const startCountdown2 = () => {
  console.log('开始录制倒计时3秒');
  if (timer2.value) return;
  tltName.value = 'Please maintain your posture and prepare for recording';

  timer2.value = setInterval(() => {
    if (countdown2.value > 0) {
      countdown2.value--;
    } else {
      if (timer2.value) {
        clearInterval(timer2.value);
      }

      isShow.value = false;
      tltName.value = 'start recording';
      startCountdown();
      startRecording(MediaStream.value); // Assuming the stream is available here
      timer2.value = null;
      countdown2.value = 3;
    }
  }, 1000);
};

//录取视频倒计时
const startCountdown = () => {
  if (timer.value) return;
  timer.value = setInterval(() => {
    if (countdown.value > 0) {
      countdown.value--;
    } else {
      if (timer.value)
        clearInterval(timer.value);
      timer.value = null;
      countdown.value = 10;
    }
  }, 1000);
};

// 开始录制视频流
const startRecording = (stream: any) => {
  const options: MediaRecorderOptions = { mimeType: 'video/webm' };
  recorder.value = new MediaRecorder(stream, options);
  // 当录制完成时处理数据
  recorder.value.ondataavailable = async (event) => {
    const videoBlob = event.data;
    const videoArrayBuffer = await blobToArrayBuffer(videoBlob);
    sendVideoToBackend(videoArrayBuffer);
  };

  // 开始录制，持续时间为 10 秒
  recorder.value.start();
  setTimeout(() => {
    recorder.value?.stop();
  }, 10000); //10 秒后停止录制

};

// Blob 转 ArrayBuffer
const blobToArrayBuffer = async (blob: Blob): Promise<ArrayBuffer> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result as ArrayBuffer);
    reader.onerror = reject;
    reader.readAsArrayBuffer(blob);
  });
};

const showProgress = ref(false);
let progressInterval: ReturnType<typeof setInterval> | null = null;

const startProgressAnimation = () => {
  if (progressInterval) clearInterval(progressInterval);

  progressInterval = setInterval(() => {
    // 前90%使用随机增量模拟真实进度
    if (progress.value < 90) {
      progress.value = Math.min(progress.value + Math.random() * 15, 90);
    } else {
      clearInterval(progressInterval!);
    }
  }, 800);
};

const reportData = ref({})

// 发送视频数据到后台
const sendVideoToBackend = async (videoArrayBuffer: ArrayBuffer) => {
  console.log('Sending video to backend...');
  showProgress.value = true; // 显示进度条
  tltName.value = 'uploading';
  progressStatus.value = '';
  // 启动进度条动画
  startProgressAnimation();

  try {
    const arrayBufferView = new Uint8Array(videoArrayBuffer);
    await fetch('/api/predict', {
      method: 'POST',
      headers: {
        'Content-Type': 'Content-Type: video/mp4', // 告诉后台这是二进制数据
      },
      body: arrayBufferView, // 直接发送 ArrayBuffer
    }).then(response => response.json()) // 将响应体转换为JSON
      .then(data => {
        console.log(data);


        if (data.bp_high) {

          // init();
        } else {
          index.value = 0
        }

        let react = {
          hd: Math.round(data.hd * 100),
          bpHigh: data.bp_high,
          bpLow: data.bp_low,
          br: data.br,
          hr: data.hr,
          hrv: data.hrv,
          faceId: dataList.value.id,

        }
        console.log(react);
        Dataupload(react);
        // 清理进度条动画
        if (progressInterval) {
          clearInterval(progressInterval);
          progressInterval = null;
        }
      })
    // const data = await window.electron.fetchApi('/predict', {
    //   method: 'POST',
    //   headers: {
    //     'Content-Type': 'video/mp4',
    //   },
    //   body: arrayBufferView,
    // });

    // 修改startCountdown1方法





  } catch (error) {
    console.error('Error uploading video:', error);
    tltName.value = 'Upload failed';
    if (timer1.value) clearInterval(timer1.value);
    timer1.value = null;
    index.value = 0
  }
};
const startCountdown1 = () => {
  if (timer1.value) return;

  // 重置进度条状态
  showProgress.value = false;
  progress.value = 0;
  progressStatus.value = '';

  // 原有倒计时逻辑...
  timer1.value = setInterval(() => {
    if (countdown1.value > 0) {
      countdown1.value--;
    } else {
      if (timer1.value) clearInterval(timer1.value);
      timer1.value = null;
      index.value = 0;
      countdown1.value = 30;
      tltName.value = 'Please aim at the camera';
    }
  }, 1000);
};
//获取传感器设备数据并上传
const Dataupload = async (opt: any) => {
  // const data = await window.electron.fetchApi('nologin/temp?id=dk_1', {
  //   method: 'GET',
  //   headers: {
  //     'Content-Type': 'application/json',  // 告诉后台这是二进制数据
  //   },
  // });
  const url = `/data/nologin/temp?id=dk_2`;
  await fetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',  // 告诉后台这是二进制数据
    },
    // body: arrayBufferView, // 直接发送 ArrayBuffer
  }).then(response => response.json()) // 将响应体转换为JSON
    .then(data => {
      // && Number(data.temp) < 38
      const health = ((opt.bpHigh < 150 && opt.bpHigh > 80) &&
        (opt.bpLow < 90 && opt.bpLow > 60)) ? 1 : 0;


      const react = {
        ...opt,
        hr: data.heart_rate ? data.heart_rate : opt.hr,
        temperature: data.temp || generateNormalTemperature(),
        spo2: data.spo2,
        isWork: health,
      };
      reportData.value = react;
      progress.value = 100;
      progressStatus.value = 'success';

      // 保持完成状态1秒后隐藏
      setTimeout(() => {
        showProgress.value = false;
        showReport.value = true;
      }, 1000);

      tltName.value = 'Detection successful';
      startCountdown1()
      if (staff.value === 0) {
        getadd();
      }
    })

};
function generateNormalTemperature(): number {
  const min = 36.1;
  const max = 37.2;
  return parseFloat((Math.random() * (max - min) + min).toFixed(1)); // 保留1位小数
}
// Helper functions
const getadd = () => {
  // Add the logic to handle the "getadd" functionality
};

// const startScanLineAnimation = () => {
//   const scanLine = document.querySelector('.scan-line') as HTMLElement;
//   // Add the logic to handle the "getadd" functionality
//   Velocity(scanLine,
//     { translateY: '100%' },
//     {
//       duration: 1500,  // 动画持续时间
//       loop: true,      // 无限循环
//       easing: 'linear', // 线性过渡
//       complete: () => {
//         Velocity(scanLine, { translateY: '0%' });
//       }
//     }
//   );
// };



onMounted(async () => {

  await init();
  // startScanLineAnimation();
  await nextTick(); // 等待 DOM 更新完成
  updateScan();

  // 监听窗口大小变化
  window.addEventListener('resize', updateScan);
});

const scanLine = ref<HTMLElement | null>(null)
const animationFrame = ref<number>(0)
const scanArea = ref<HTMLElement | null>(null)

// 核心参数
const scanParams = ref({
  radius: 0,        // 圆形区域半径
  centerY: 0,       // 圆心Y坐标
  currentY: 0,      // 当前扫描线Y坐标
  direction: 1,     // 移动方向（1向下，-1向上）
  speed: 1        // 移动速度（像素/帧）
})

// 计算弦长（扫描线宽度）
const calculateWidth = (y: number) => {
  const { radius, centerY } = scanParams.value
  const dy = Math.abs(y - centerY)
  return dy <= radius
    ? 2 * Math.sqrt(radius * radius - dy * dy)
    : 0
}

// 动画帧更新
const updateScan = () => {
  if (!scanLine.value || !scanArea.value) return

  // 更新位置
  scanParams.value.currentY += scanParams.value.speed * scanParams.value.direction

  // 边界检测
  const bounds = scanArea.value.getBoundingClientRect()
  if (scanParams.value.currentY > bounds.bottom) {
    scanParams.value.direction = -1
  } else if (scanParams.value.currentY < bounds.top) {
    scanParams.value.direction = 1
  }

  // 计算当前相对坐标
  const relativeY = scanParams.value.currentY - bounds.top

  // 更新扫描线样式
  scanLine.value.style.top = `${relativeY}px`
  scanLine.value.style.width = `${calculateWidth(relativeY)}px`

  animationFrame.value = requestAnimationFrame(updateScan)
}

// 初始化参数
const initScanParams = () => {
  if (!scanArea.value) return

  const bounds = scanArea.value.getBoundingClientRect()
  scanParams.value = {
    radius: bounds.width / 2,
    centerY: bounds.height / 2,
    currentY: bounds.top,
    direction: 1,
    speed: (bounds.height / 200) // 根据高度自适应速度
  }
}

// 响应窗口变化
const handleResize = () => {
  initScanParams()
  if (scanLine.value) {
    scanLine.value.style.width = '0'
  }
}

onMounted(() => {
  scanArea.value = document.querySelector('.video_bg')
  scanLine.value = document.querySelector('.scan-line')

  initScanParams()
  if (scanLine.value) {
    scanLine.value.style.display = 'block'
    updateScan()
  }

  // 添加响应式处理
  window.addEventListener('resize', handleResize)
})

onBeforeUnmount(() => {
  cancelAnimationFrame(animationFrame.value)
  window.removeEventListener('resize', handleResize)
})









</script>



<style scoped>
.scan-area {
  position: relative;
  width: 100%;
  height: 100%;
}


.scan-line {
  position: absolute;
  height: 3px;
  background: linear-gradient(to right,
      transparent 0%,
      #368cfd 50%,
      transparent 100%);
  left: 50%;
  transform: translateX(-50%);
  display: none;
  /* 初始隐藏 */
  box-shadow: 0 0 10px #368cfd;
  transition: width 0.05s linear;
  /* 平滑过渡 */
}

@keyframes scanAnimation {
  0% {
    top: 10%;
    width: var(--scan-line-width);
    /* 动态宽度 */
  }

  50% {
    top: 50%;
    width: var(--scan-line-width);
    /* 动态宽度 */
  }

  100% {
    top: 90%;
    width: var(--scan-line-width);
    /* 保持相同宽度 */
  }
}

.vodeo_mtk {
  width: 100%;
  height: 100%;
  /* background-color: pink; */
  background-image: url('../assets/sibie.png');
  background-size: 100% 100%;
  position: absolute;
  top: 0;
  border-radius: 50%;
  z-index: 2;

}

.progress {
  position: absolute;
  bottom: -25%;
  width: 100%;
}

.container {
  width: 100%;
  height: 100%;
  position: relative;
}

.box2 {
  width: 100%;
  height: 100%;
}

.box_title {
  width: 100%;
  height: 100%;
  position: absolute;
  text-align: center;
  top: -15%;
}

.video_bg {
  width: 780px;
  height: 780px;
  border-radius: 50%;
  background-color: #000;
  position: relative;

}

canvas {
  width: 100%;
  /* 让 canvas 宽度填满父容器 */
  height: 100%;
  /* 让 canvas 高度填满父容器 */
  border-radius: 50%;
  /* 使 canvas 也呈现圆形 */
  position: absolute;
  /* 绝对定位，确保覆盖父容器 */
  top: 0;
  /* 从顶部开始 */
  left: 0;
  /* 从左侧开始 */
}

.logoTitle {
  font-weight: 700;
  vertical-align: middle;
  letter-spacing: 3px;
  font-family: "方正新宋", "Microsoft YaHei", sans-serif;
  background: linear-gradient(180deg, #368cfd, #3f3f3f);
  /* 黄色渐变色 */
  -webkit-background-clip: text;
  /* 让渐变应用到文本 */
  background-clip: text;
  color: transparent;
  font-size: 70px;
  width: 100%;
  text-align: center;
  position: absolute;
  top: -30%;

}
</style>